import React from 'react';

import * as stringUtil from "../util/stringUtil";

import recommendCss from '../pages/recommend/recommend.module.css';

const CouponChargeComp = ({
    couponList,
    selectedCoupon,
    cashAmount,
    freeAmount,
    sndGoalCnt,
    billingType,
    txtMessageUnit,
    imgMessageUnit,
    handleCouponChange,
    userPackage,
    usePackage,
    selectedTgtCompanyName
}) => {

    const availableCouponList = couponList.filter((item) => (
        !item.tgtCompanyName || item.tgtCompanyName === selectedTgtCompanyName
    ));
    let fee = billingType === 3 ? sndGoalCnt * txtMessageUnit : sndGoalCnt * imgMessageUnit;
    let couponCnt = (Object.keys(selectedCoupon).length === 0 ? 0 : selectedCoupon.amount);
    let discount = (billingType === 3 ? couponCnt * txtMessageUnit : couponCnt * imgMessageUnit);
    let balance = (cashAmount+freeAmount) - (fee > discount ? (fee-discount) : 0);

    return (
        <div className={`row ${recommendCss["coupon-area"]} mt-3`}>
            {  !usePackage ? (
            <div className='col-lg-12 px-sm-5'>
                <div className='card-body border rounded'>
                    <div className={`row justify-content-center`}>
                        <div className='col-lg-3'>
                            <label className='d-block fs-5'>쿠폰</label>
                            <select className="form-select d-inline me-0 me-sm-2" value={JSON.stringify(selectedCoupon)} onChange={handleCouponChange}>
                                <option value='{}'>쿠폰 선택</option>
                                {availableCouponList.map((item, index) => (
                                    <option key={index} value={JSON.stringify(item)}>
                                        {`${item.name} (${item.amount})${item.tgtCompanyName ? ` - ${item.tgtCompanyName}` : ''}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='col-lg-3'>
                            <label className='d-block fs-5'>잔여 무료 포인트</label>
                            <input className='form-control w-lg-auto d-inline' type="text" value={`${stringUtil.formatNumber(freeAmount)} P`} readOnly={true}/>
                        </div>
                        <div className='col-lg-auto d-flex flex-column justify-content-center pt-lg-0 pt-3 h-100'>
                            <h4 className='fs-5 text-center'>현재 포인트</h4>
                            <p className='m-0 text-center'><span>{stringUtil.formatNumber(cashAmount+freeAmount)}</span><small>P</small></p>
                        </div>
                        <div
                            className='col-lg-auto fs-3 fw-bold operator d-flex flex-column justify-content-center text-primary px-lg-3 text-center'>-
                        </div>
                        <div className='col-lg-auto d-flex flex-column justify-content-center h-100'>
                            <h4 className='fs-5 text-center'>사용 포인트</h4>
                            <p className='m-0 text-center'>
                                <span>{stringUtil.formatNumber(fee > discount ? fee-discount : 0)}</span><small>P</small>
                            </p>
                            {/* 할인 금액 출력 */}
                            <small className='text-muted fw-medium d-block text-decoration-line-through text-center'>
                                <span>{stringUtil.formatNumber(fee > discount ? discount : fee)}</span><span>P</span>
                            </small>
                        </div>
                        <div
                            className='col-lg-auto fs-3 fw-bold operator d-flex flex-column justify-content-center text-primary px-lg-3 text-center'>=
                        </div>
                        <div className='col-lg-auto d-flex flex-column justify-content-center text-center h-100'>
                            <h4 className='fs-5 text-primary fw-bold'>잔여 포인트</h4>
                            <p className='m-0'><span className={`${balance < 0 ? 'text-danger' : ''}`}>{stringUtil.formatNumber(balance)}</span><small>P</small></p>
                            {/*<small className='text-muted fw-medium d-block'>* VAT 10% 별도</small>*/}
                        </div>
                    </div>
                    <p style={{color: 'red', textAlign: 'center', wordBreak: 'keep-all', marginTop: '0.75rem', marginBottom: 0, fontSize: '0.85rem'}}>
                        분양 광고는 반드시 <strong>1:1 문의</strong> 부탁드립니다. 비즈팅 사이트 내에서는 분양광고 진행이 어려우며, <strong>대행발송으로 진행</strong>되는 점 참고 부탁드립니다. <strong>포인트 충전 전 반드시 확인 부탁드립니다.</strong>
                    </p>
                </div>
            </div>
            ) : (
            <div className='col-lg-12 px-sm-5'>
                <div className='card-body border rounded'>
                    <div className={`row justify-content-center`}>
                        <div className='col-lg-3'>
                            <label className='d-block fs-5'>패키지</label>
                            <label className='d-block fs-5'>{userPackage.name}</label>
                        </div>
                        <div className='col-lg-3'>
                            <label className='d-block fs-5'>잔여 발송 횟수</label>
                            <input className='form-control w-lg-auto d-inline' type="text" value={`${userPackage.amount}`} readOnly={true}/>
                        </div>
                        <div className='col-lg-auto d-flex flex-column justify-content-center pt-lg-0 pt-3 h-100'>
                            <h4 className='fs-5 text-center'>현재 패키지 포인트</h4>
                            <p className='m-0 text-center'><span>{stringUtil.formatNumber(userPackage.pointBalance)}</span><small>P</small></p>
                        </div>
                        <div
                            className='col-lg-auto fs-3 fw-bold operator d-flex flex-column justify-content-center text-primary px-lg-3 text-center'>-
                        </div>
                        <div className='col-lg-auto d-flex flex-column justify-content-center h-100'>
                            <h4 className='fs-5 text-center'>사용 패키지 포인트</h4>
                            <p className='m-0 text-center'>
                                <span>{stringUtil.formatNumber(userPackage.unit * userPackage.sendCnt * 6)}</span><small>P</small>
                            </p>
                        </div>
                        <div
                            className='col-lg-auto fs-3 fw-bold operator d-flex flex-column justify-content-center text-primary px-lg-3 text-center'>=
                        </div>
                        <div className='col-lg-auto d-flex flex-column justify-content-center text-center h-100'>
                            <h4 className='fs-5 text-primary fw-bold'>잔여 포인트</h4>
                            <p className='m-0'><span>{stringUtil.formatNumber(0)}</span><small>P</small></p>
                            {/*<small className='text-muted fw-medium d-block'>* VAT 10% 별도</small>*/}
                        </div>
                    </div>
                    <p style={{color: 'red', textAlign: 'center', wordBreak: 'keep-all', marginTop: '0.75rem', marginBottom: 0, fontSize: '0.85rem'}}>
                        분양 광고는 반드시 <strong>1:1 문의</strong> 부탁드립니다. 비즈팅 사이트 내에서는 분양광고 진행이 어려우며, <strong>대행발송으로 진행</strong>되는 점 참고 부탁드립니다. <strong>포인트 충전 전 반드시 확인 부탁드립니다.</strong>
                    </p>
                </div>
            </div>
            )
            }
            {/* <div className='text-center pt-2 pt-lg-4 '>
                <button className='btn btn-lg btn-primary btn-lg-summit'>저장</button>
            </div> */}
        </div>
    );
};

export default CouponChargeComp;
